import { AcontoClientView, CaseInvoicing, CaseName, Faktura, Fakturalinjer, FakturaView, InvoiceListPeriod, PatchObject } from '@store/models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root'})
export class FakturaService {

    constructor(
        private http: HttpClient
    ) {}

    fakturaViewByOffice(options: InvoiceListPeriod): Observable<FakturaView[]> {
        const url = `[api]/model/Faktura/viewByOffice/[officeid]`;
        return this.http.post<FakturaView[]>(url, options);
    }

    fakturaViewByKid(kid: number): Observable<FakturaView[]> {
        const url = `[api]/model/Faktura/viewByKid/${kid}`;
        return this.http.get<FakturaView[]>(url);
    }

    fakturaByFnr(fnr: number): Observable<Faktura> {
        const url = `[api]/model/Faktura/byFnrWithRecords/${fnr}`;
        return this.http.get<Faktura>(url);
    }

    createFaktura(kid: number) {
        const url = `[api]/model/Faktura/${kid}`;
        return this.http.post<Faktura>(url, null);
    }

    updateFaktura(fnr: number, patchValues: PatchObject[]) {
        const url = `[api]/model/Faktura/${fnr}`;
        return this.http.patch<Faktura>(url, patchValues);
    }

    godkendFaktura(fnr: number): Observable<Faktura> {
        const url = `[api]/model/Faktura/godkend/${fnr}`;
        return this.http.post<Faktura>(url, null);
    }

    deleteFaktura(fnr: number): Observable<boolean> {
        const url = `[api]/model/Faktura/${fnr}`;
        return this.http.delete<boolean>(url);
    }

    godkendFakturaBulk(fnrs: number[]) {
        const url = `[api]/model/Faktura/godkendBulk`;
        return this.http.post<Faktura>(url, fnrs);
    }

    casesWithTotals(kid: number) {
        const url = `[api]/sager/withInvoicingTotals/${kid}`;
        return this.http.get<CaseInvoicing[]>(url);
    }

    caseNames(kid: number) {
        const url = `[api]/sager/caseNamesByKid/${kid}`;
        return this.http.get<CaseName[]>(url);
    }

    deleteFakturalinje(flid: number) {
        const url = `[api]/model/faktura/fakturalinjer/${flid}`;
        return this.http.delete<Faktura>(url);
    }

    saveFakturalinje(fakturalinje: Fakturalinjer) {
        const url = `[api]/model/faktura/fakturalinjer`;
        return this.http.post<Faktura>(url, fakturalinje);
    }

    emailFakutra(faktura: Faktura, fakturaBlob: Blob) {
        const url = `[api]/model/faktura/emailfaktura/${faktura.fnr}`;
        const fakturafile = new File([fakturaBlob], `Faktura-${faktura.fakturanr}.pdf`, { lastModified: new Date().getTime(), type: fakturaBlob.type });
        const formData = new FormData();
        formData.append('fakturafile', fakturafile);
        return this.http.post<Faktura>(url, formData);
    }

    acontoClients(period: Date, acontoType: number) {
        const url = `[api]/model/Faktura/acontoClientsView/[officeid]/${acontoType}`;
        return this.http.post<AcontoClientView[]>(url, period);
    }

    acontoBulk(period: Date, acontoType: number) {
        const url = `[api]/model/Faktura/acontoBulk/[officeid]/${acontoType}`;
        return this.http.post<Faktura[]>(url, period);
    }

    fakturaByFakturanr(fakturanr: number) {
        const url = `[api]/model/Faktura/byFakturanrWithRecords/[officeid]/${fakturanr}`;
        return this.http.get<Faktura>(url);
    }
}
